import { render, staticRenderFns } from "./BulletinBoardTab1.vue?vue&type=template&id=784eb0d5"
import script from "./BulletinBoardTab1.vue?vue&type=script&lang=js"
export * from "./BulletinBoardTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports